export default "assets/f7f45221f0c2ecb19fd6a8ebcd0d5f7c.png";